import { useLayoutEffect, useEffect } from 'react';

// useLayoutEffect will generate a warning if used during ssr, so we replace it with useEffect.
export const useIsomorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
